<template>
    <div class="overall-bg">
        <b-container>
            <b-row>
                <b-col>
                    <BackBtn :goback="$router.back" />
                    <p v-if="paramValue == 'Grn With Po'">
                        <Headerlayout headertext="Grn With Po"></Headerlayout>
                    </p>

                    <p v-if="paramValue == 'Grn Without Po'">
                        <Headerlayout headertext="Grn Without Po"></Headerlayout>
                    </p>

                    <p v-if="paramValue == 'Opening Stock'">
                        <Headerlayout headertext="Add Stock"></Headerlayout>
                    </p>

                    <p v-if="paramValue == 'Issue'">
                        <Headerlayout headertext="Issue"></Headerlayout>
                    </p>

                    <p v-if="paramValue == 'Issue Return'">
                        <Headerlayout headertext=" Issue Return"></Headerlayout>
                    </p>

                    <p v-if="paramValue == 'Consumption Return'">
                        <Headerlayout headertext="Consumption Return"></Headerlayout>
                    </p>
                </b-col>
            </b-row>

            <b-row class="form-white-bg">
                <div v-if="paramValue == 'Grn Without Po'">
                    <b-row>
                        <b-col lg="6">
                            <Supplier :showone="paramValue" />
                        </b-col>
                        <b-col lg="6">

                            <GRN :showone="paramValue" />
                            <Invoice :showone="paramValue" />
                        </b-col>
                        <b-col lg="12">

                            <Items :showone="paramValue" />
                        </b-col>
                    </b-row>
                </div>
                <div v-if="paramValue == 'Grn With Po'">
                    <b-row>
                        <b-col lg="6">
                            <Supplier :showone="paramValue" />
                        </b-col>
                        <b-col lg="6">
                            <PurchaseOrder :showone="paramValue" />
                            <Invoice :showone="paramValue" class="mt-2" />
                        </b-col>
                    </b-row>
                </div>
                <div v-if="paramValue == 'Opening Stock'">
                    <b-row>
                        <b-col lg="6">
                            <Supplier :showone="paramValue" />
                        </b-col>
                        <b-col lg="6">
                            <GRN :showone="paramValue" />
                            <Invoice :showone="paramValue" />
                        </b-col>
                        <b-col lg="12">
                            <Items :showone="paramValue" />
                        </b-col>
                    </b-row>
                </div>
                <div v-if="paramValue == 'Consumption Return'">
                    <b-row>
                        <b-col lg="12">
                            <Items :showone="paramValue" />
                        </b-col>
                    </b-row>
                </div>

                <b-row class="py-5">
                    <b-col>
                        <Table :columns="headers"></Table>
                    </b-col>
                </b-row>

                <!-- <b-row>
                    <b-col lg="6" sm="6" v-if="paramValue == 'Grn Without Po'
                        || paramValue == 'Grn With Po' ||
                        paramValue == 'Opening Stock'">
                        <Supplier :showone="paramValue" />
                    </b-col>
                    <b-col lg="6" sm="6" v-if="paramValue == 'Grn With Po'">
                        <PurchaseOrder :showone="paramValue" />
                    </b-col>
                    <b-col lg="6" sm="6" v-if="paramValue == 'Grn Without Po'
                        || paramValue == 'Grn With Po' ||
                        paramValue == 'Opening Stock'">
                        <Invoice :showone="paramValue" />
                    </b-col>
                    <b-col lg="12" sm="12" v-if="paramValue == 'Grn Without Po' ||
                        paramValue == 'Consumption Return' ||
                        paramValue == 'Opening Stock'">
                        <Items :showone="paramValue" />
                    </b-col>


                    <b-col lg="6" sm="6" v-if="paramValue == 'Consumption Return'">
                        <Return :showone="paramValue" />
                    </b-col>
                </b-row>

                <b-row class="py-5">
                    <b-col>
                        <Table :columns="headers"></Table>
                    </b-col>
                </b-row> -->

                <Footer />
            </b-row>
        </b-container>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, PropType, computed } from 'vue'
import BackBtn from '../../../../../components/FormComponents/BacktoMaster.vue'
import Headerlayout from '../../../../../components/Masters/HeaderLayout.vue'
import Table from '../../../../../components/FormComponents/Table.vue'
import Supplier from '../../../../../modules/Inventory/components/Transaction/SupplierComponent.vue'
import Invoice from '../../../../../modules/Inventory/components/Transaction/Invoice.vue'
import PurchaseOrder from '../../../../../modules/Inventory/components/Transaction/PurchaseOrder.vue'
import Return from '../../../../../modules/Inventory/components/Transaction/Return.vue'
import GRN from '../../../../../modules/Inventory/components/Transaction/stockin/grn.vue'

import Items from '../../../../../modules/Inventory/components/Transaction/Item.vue'
import { useRoute } from 'vue-router';
import Footer from '../../../../../components/FormComponents/Footer.vue'
export default defineComponent({
    components: {
        BackBtn,
        Headerlayout,
        Table,
        Supplier,
        Items,
        Footer,
        Invoice,
        PurchaseOrder,
        Return,
        GRN
    },

    setup() {
        const route = useRoute();

        const paramValue = computed(() => {
            return route.query.param as string;
        });
        let List = ref([])
        const headers = [
            {
                header: 'Item',
                field: ''
            },
            {
                header: 'HSN',
                field: ''
            },
            {
                header: 'Item Name',
                field: ''
            },
            {
                header: 'Purchaseing Unit',
                field: ''
            },
            {
                header: 'PO Quantity',
                field: ''
            },
            {
                header: 'Qty',
                field: ''
            },
            {
                header: 'UOM',
                field: ''
            },
            {
                header: 'Unit Rate',
                field: ''
            },
            {
                header: 'Tax',
                field: ''
            },
            {
                header: 'Discount %',
                field: ''
            },
            {
                header: 'Discount Amount',
                field: ''
            },
            {
                header: 'Tax Value',
                field: ''
            },
            {
                header: 'Sales Unit',
                field: ''
            },
            {
                header: 'Sales Tax',
                field: ''
            },
            {
                header: 'Margin',
                field: ''
            },
            {
                header: 'Sales Price',
                field: ''
            },
            {
                header: 'MRP',
                field: ''
            },

        ];


        return {
            List,
            headers,
            paramValue
        }
    }

})
</script>

